import baseAxios from "./index";

export function selectSalary(url,data) {
    return baseAxios.post(url,data);
}

export function getOpenId(url,data) {
    return baseAxios.post(url,data)
}

export function getPerson(url) {
    return baseAxios.get(url)
}

export function httpAction(method,url,param){
    return baseAxios({
        url:url,
        method:method,
        data:param
    })
}
export function getHttpAction(url,param){
    return baseAxios({
        url:url,
        method:'get',
        params:param
    })
}

export function httpActionGetHeader(url,contentType,param){
    return baseAxios({
        url:url,
        method:'get',
        headers:{
            'Content-Type': contentType == 'form' ? 'application/x-www-form-urlencoded' :'application/json'
        },
        params:param
    })
}

export function httpActionPostHeader(url,contentType,param){
    return baseAxios({
        url:url,
        method:'get',
        headers:{
            'content-type': contentType == 'form' ? 'application/x-www-form-urlencoded' :'application/json'
        },
        params:param
    })
}